import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_176_1602)">
      <rect
        y="0.5"
        width="18"
        height="18"
        rx="9"
        fill="url(#paint0_linear_176_1602)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 9.5C18 14.4706 13.9706 18.5 9 18.5C4.02944 18.5 0 14.4706 0 9.5C0 4.52944 4.02944 0.5 9 0.5C13.9706 0.5 18 4.52944 18 9.5ZM14.1492 9.97186L11.6029 11.4422V11.4425C11.4681 11.5201 11.3009 11.5201 11.166 11.4425L10.2084 10.8895V9.50626L11.3843 10.1854L13.1699 9.15458V7.09263L11.3843 6.06185L9.63104 7.07426L9.5987 7.09263V12.3473C9.5987 12.5027 9.51528 12.6479 9.38041 12.7258L6.83413 14.1957C6.69927 14.2732 6.53169 14.2732 6.3972 14.1957L3.85091 12.7254C3.71642 12.6475 3.63263 12.5023 3.63263 12.3469V9.40667C3.63263 9.25086 3.71605 9.10607 3.85091 9.02816L6.3972 7.55787C6.46298 7.51965 6.53868 7.49944 6.61548 7.49944C6.69228 7.49944 6.76798 7.51965 6.83413 7.55787L7.79363 8.11166V9.49486L6.61585 8.81502L4.83025 9.84581V11.9078L6.61585 12.9385L8.40144 11.9078V6.65313C8.40144 6.49768 8.48486 6.35253 8.61973 6.27462L11.166 4.80432C11.3009 4.72679 11.4681 4.72642 11.6029 4.80432L14.1492 6.27462C14.2837 6.35253 14.3675 6.49768 14.3675 6.65313V9.59335C14.3675 9.74916 14.2841 9.89395 14.1492 9.97186Z"
        fill="#F5F0FD"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_176_1602"
        x1="1.52312"
        y1="15.6526"
        x2="18.2537"
        y2="4.84284"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A726C1" />
        <stop offset="0.88" stopColor="#803BDF" />
        <stop offset="1" stopColor="#7B3FE4" />
      </linearGradient>
      <clipPath id="clip0_176_1602">
        <rect y="0.5" width="18" height="18" rx="9" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
